export class PatientMatchVerification {
  id?: number;
  matches: boolean;
  notes: string;
  frozen: boolean;
}
